import { FirebaseApp, getApps, initializeApp } from 'firebase/app';
import { browserLocalPersistence, connectAuthEmulator, indexedDBLocalPersistence, initializeAuth } from 'firebase/auth';
import React from 'react';
import settings from 'web/utils/settings';
import { isClientSide } from 'web/utils/ssr';
import { shouldUseEmulators } from './common';

const firebaseConfig = {
  apiKey: settings.firebase.apiKey,
  authDomain: settings.firebase.authDomain,
  databaseURL: settings.firebase.databaseURL,
  projectId: settings.firebase.projectId,
  storageBucket: settings.firebase.storageBucket,
  messagingSenderId: settings.firebase.messagingSenderId,
  appId: settings.firebase.appId,
  measurementId: settings.firebase.measurementId,
};

const initAuth = (firebase: FirebaseApp) => {
  const auth = initializeAuth(firebase, {
    persistence: isClientSide
      ? [indexedDBLocalPersistence, browserLocalPersistence]
      : // Could also use in-memory persistence if needed server-side
        undefined,
  });

  if (shouldUseEmulators) {
    connectAuthEmulator(auth, 'http://localhost:9099');
  }

  return auth;
};

const initFirebase = () => {
  const firebase = initializeApp(
    firebaseConfig,
    isClientSide ? undefined : `[${getApps().length}]`, // server-side multiple apps from different bundles can co-exist
  );
  initAuth(firebase);
  return firebase;
};

const firebase = initFirebase();

const FirebaseContext = React.createContext<FirebaseApp>(firebase);

export { firebase, firebaseConfig, initAuth };
export default FirebaseContext;
